import { overrideProperties } from '@/utils/util'

const FORM_ACTION = {
  NONE: 'none',
  CREATE: 'create',
  UPDATE: 'update'
}

export default {
  data() {
    return {
      title: '',
      visible: false,
      submitLoading: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
        md: { span: 6 },
        lg: { span: 6 },
        xl: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 17 },
        md: { span: 17 },
        lg: { span: 17 },
        xl: { span: 17 }
      },
      form: this.$form.createForm(this),
      formAction: FORM_ACTION.NONE,
      reqFunctions: {
        create: function () {},
        update: function () {},
        none: function () {}
      },
      updateKey: 'id',
      record: {}
    }
  },
  computed: {
    isCreateForm() {
      return this.formAction === FORM_ACTION.CREATE
    },
    isUpdateForm() {
      return this.formAction === FORM_ACTION.UPDATE
    }
  },
  methods: {
    show(attributes) {
      this.title = attributes && attributes.title
      this.visible = true
      this.submitLoading = false
      this.buildShowedForm(attributes)
    },
    add(attributes) {
      this.show(attributes)
      this.buildCreatedForm(attributes)
      this.formAction = FORM_ACTION.CREATE
    },
    async update(record, attributes) {
      this.show(attributes)
      this.record = record
      await this.buildUpdatedForm(record, attributes)
      this.formAction = FORM_ACTION.UPDATE
      this.$nextTick(() => {
        setTimeout(() => {
          const formData = overrideProperties(this.form.getFieldsValue(), record)
          this.form.setFieldsValue(formData)
        }, 0)
      })
    },
    handleSubmit(e) {
      e && e.preventDefault()
      const reqFunction = this.reqFunctions[this.formAction]
      // 表单提交前事件，返回 false 时停止提交
      if (this.beforeStartSubmit() === false) return
      this.form.validateFields((err, values) => {
        if (!err) {
          // console.log(this.submitDataProcess(values))
          this.submitLoading = true
          reqFunction(this.submitDataProcess(values))
            .then(res => {
              if (res.code === 200) {
                this.$message.success(res.message)
                this.submitSuccess(res)
              } else {
                this.submitError(res)
              }
            })
            .catch(error => {
              this.$message.error(error.response.data.message)
            })
            .finally(() => {
              this.submitLoading = false
            })
        }
      })
    },
    beforeStartSubmit() {},
    submitDataProcess(values) {
      return values
    },
    submitSuccess(res) {
      this.$emit('confirm')
      this.handleClose()
    },
    submitError(res) {
      this.$message.warning(res.message)
    },
    handleClose() {
      this.record = {}
      this.form.resetFields()
      this.visible = false
      this.submitLoading = false
      this.$emit('close')
    },
    buildShowedForm(attributes) {},
    // add函数 额外操作
    buildCreatedForm(attributes) {},
    // update 额外操作
    buildUpdatedForm(record, attributes) {}
  }
}
